import { InjectionToken } from '@angular/core';
import { LoggerParamsTransformer } from '@content-platform/web-angular-shared-util-logging';
export const REPORT_PARAM_TRANSFORMERS = new InjectionToken('report-param-transformers');
export class ReportParamsTransformer extends LoggerParamsTransformer {
}
//# sourceMappingURL=report-params.js.map